var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sapp-loading uiLoading",class:_vm.classes},[_c('div',{staticClass:"uiLoadingDot dot-1"}),_c('div',{staticClass:"uiLoadingDot dot-2"}),_c('div',{staticClass:"uiLoadingDot dot-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }